'use strict';

var cartListPage = void 0;
var cartList = function () {

  var $cartButton = $('.js-cartList-button');
  var arrLegalTexts = void 0;

  var _getLegal = function _getLegal() {
    return arrLegalTexts;
  };

  var _getObjLS = function _getObjLS() {
    return JSON.parse(localStorage.cartList);
  };
  var _refreshObjLS = function _refreshObjLS(obj) {
    return localStorage.cartList = JSON.stringify(obj);
  };
  var _init = function _init() {
    var blankObjLS = {
      id: sessionStorage.myId,
      items: []
    };
    if (!localStorage.cartList) {
      // Si no existe el objeto carrito en localStorage, se crea en blanco con la id de la concesión
      localStorage.cartList = JSON.stringify(blankObjLS);
    } else {
      // Si existe el objeto carrito pero para una concesión con id distinta a la actual, se crea en blanco de nuevo
      var objLS = _getObjLS();
      if (objLS.id !== sessionStorage.myId) {
        localStorage.cartList = JSON.stringify(blankObjLS);
      } else {
        // Si existe el carrito y no está vacío se muestra el elemento en página y se marcan los checks en las páginas listado y ficha
        var _objLS = _getObjLS();
        if (_objLS.items.length > 0) {
          _refreshCounter();
        }
      }
    }

    // Ponemos en sesión la URL a la que se puede volver desde el listado;

    $cartButton.on('click', function () {
      sessionStorage.backFromCartList = window.location.href;
    });
  };

  var _getTotalCount = function _getTotalCount(obj) {
    var total = 0;
    for (var i = 0; i < obj.items.length; i++) {
      total += obj.items[i].sum;
    }
    return total;
  };

  var _checkboxListener = function _checkboxListener($button) {
    if ($button.prop('checked')) {
      _addToCartList($button.data('ref'));
    } else {
      console.log('ref a borrar', $button.data('ref'));
      _removeAllFromCarList($button.data('ref'), modelmoi);
    }
  };

  var _addToCartList = function _addToCartList(ref) {
    var obj = _getObjLS();
    var myMoi = modelmoi;
    var items = obj.items;
    if (items.length > 0) {
      // El carrito tiene elementos
      // Comprobamos si entre los ítems del carrito hay coincidencias de referencia
      var matchesRef = $.grep(obj.items, function (item) {
        return item.ref === ref;
      });

      if (matchesRef.length === 0) {
        // No hay coincidencias de referencia, se añade al carrito
        _pushNewItem(ref, myMoi);
      } else {
        // Si hay coincidencias
        // Comprobamos si también hay coincidencias en cuanto a MOI
        var matchesMoi = $.grep(matchesRef, function (item) {
          return item.moi === myMoi;
        });

        if (matchesMoi.length === 0) {
          // No hay coincidencias en cuanto a MOI, por lo tanto es la misma referencia pero de un vehículo distinto
          // Se añade como ítem diferente
          _pushNewItem(ref, myMoi);
        } else {
          // Si hay coincidencias de MOI, por tanto se incrementa la propiedad sumatorio y se actualiza el objeto de LocalStorage y el contador
          matchesMoi[0].sum++;
          _refreshObjLS(obj);
          _refreshCounter();
        }
      }
    } else {
      // El carrito está vacío, añadimos el ítem
      _pushNewItem(ref, myMoi);
    }
  };

  var _pushNewItem = function _pushNewItem(ref, moi) {
    var obj = _getObjLS();
    // Determinar el origen de los datos del accesorio (listado - var global resultados | ficha - var global accesorio.datos)
    var newItem = void 0;
    if (typeof resultados !== 'undefined') {
      newItem = utils.getObjectByProp(resultados.listado, 'ref', ref);
      // newItem.imagen = 'img/accesorio/' + newItem.imagen
    } else {
      if (typeof accesorio.datos !== 'undefined') {
        var data = accesorio.datos;
        newItem = {
          nombre: data.nombre,
          ref: data.referencia,
          link: data.link,
          imagen: data.slides[0],
          pvp: data.pvp,
          pvc: data.pvc,
          tm: data.tm
        };
      }
    }
    newItem.sum = 1;
    newItem.moi = moi;
    newItem.refmoi = newItem.ref + newItem.moi;
    newItem.modelo = controlModelo.getModeloNameCode().name;
    newItem.modelocode = controlModelo.getModeloNameCode().code;
    obj.items.push(newItem);
    _refreshObjLS(obj);
    _refreshCounter();
  };

  var _removeAllFromCarList = function _removeAllFromCarList(ref, moi) {
    var obj = _getObjLS();
    // Coincidencias de ref y MOI
    matches = _matchRefAndMoi(ref, moi);

    // El resultado tiene que ser siempre una matriz de 1, porque las cantidades se suman en la propiedad sum del objeto, no añadiendo objetos iguales al array de LocalStorage
    if (matches.length > 0) {
      var q = void 0;
      for (var i = 0; i < obj.items.length; i++) {
        if (obj.items[i].ref === matches[0].ref && obj.items[i].moi === matches[0].moi) q = i;
      }

      obj.items.splice(q, 1);

      _refreshObjLS(obj);
      _refreshCounter();
    }
  };

  var _refreshCounter = function _refreshCounter() {
    var objLS = _getObjLS(),
        total = void 0;
    total = _getTotalCount(objLS);
    $('.js-cartList-counter').text(total);
    $cartButton.removeClass('showHide');
    var delayed = function delayed() {
      $cartButton.addClass('visible showHide');
    };

    if (total > 0) {
      window.setTimeout(delayed, 1);
    } else {
      $cartButton.removeClass('visible');
    }
  };

  // Devuelve objetos coincidentes con referencia y MOI indicados
  var _matchRefAndMoi = function _matchRefAndMoi(ref, moi) {
    var obj = _getObjLS();
    // Coincidencias de ref
    /*let matchesRef = $.grep(obj.items, (item) => item.ref === ref)
    // Concidencias de MOI y refs 
    let finalMatches = $.grep(matchesRef, (item) => item.moi === modelmoi)*/
    finalMatches = $.grep(obj.items, function (item) {
      return item.refmoi === ref + moi;
    });

    return finalMatches;
  };

  var _makeList = function _makeList() {
    // Indicamos que estamos en la página de accesorios, así se sabe que se deben redibujar los precios cuando se cambia el precio de MO
    cartListPage = true;

    _refreshCounter();

    var list = _getObjLS().items;
    var obj = _getObjLS();
    var $domList = $('.js-lista-carrito');
    var totalPVP = 0;

    $domList.empty();

    if (list.length > 0) {
      $('.js-lista-vacia').addClass('hidden');

      var _loop = function _loop(i) {
        var item = list[i];
        $block = $('#js-item-carrito-tpt').clone().removeAttr('id').removeClass('hidden');
        $block.find('.js-it-carrito-link').attr('href', item.link);
        $block.find('.js-it-carrito-img').attr({
          src: item.imagen,
          alt: item.nombre
        });
        $block.find('.js-modelo').text(item.modelo);
        $block.find('.js-code').text(item.modelocode);
        $block.find('.js-nombre').text(item.nombre);
        $block.find('.js-ref').text(item.ref);
        $block.find('.js-it-carrito-pvp').text(parseFloat(item.pvp).toLocaleString('es-ES'));
        $block.find('.js-cantidad').text(parseInt(item.sum));
        var itTotal = item.sum * item.pvp;
        $block.find('.js-it-carrito-total-pvp').text(itTotal.toLocaleString('es-ES'));
        // totalPVP = _calculateTotal();

        $block.find('.js-inc-mas').on('click', function () {
          _increment($(this).parents('.js-item-carrito'), item, list, obj, 1);
        });
        $block.find('.js-inc-menos').on('click', function () {
          _increment($(this).parents('.js-item-carrito'), item, list, obj, -1);
        });

        $block.find('.js-borrar').on('click', function () {
          _removeItem($(this).parents('.js-item-carrito'), item.ref, item.moi);
        });

        var itPriceMdo = _calculatePriceMdo(item.tm, item.sum);
        $block.find('.js-it-carrito-precio-montaje').text(itPriceMdo.toLocaleString('es-ES'));

        var subTotal = _calculateSubtotal(itTotal, itPriceMdo);
        $block.find('.js-it-carrito-subtotal').text(subTotal.toLocaleString('es-ES'));

        // Actualizamos el Objeto

        $domList.append($block);
      };

      for (var i = 0; i < list.length; i++) {
        _loop(i);
      }
    } else {
      $('.js-lista-vacia').removeClass('hidden');
    }

    totalPVP = _calculateTotal();
    $('.js-total-pvp').text(totalPVP.toLocaleString('es-ES'));
  };

  var _increment = function _increment($block, item, list, obj, increment) {
    var incBlock = $block;
    var number = parseInt(incBlock.find('.js-cantidad').text()) + increment;
    var result = number > 0 ? number : 1;
    var totalPVP = 0;

    incBlock.find('.js-cantidad').text(result);

    item.sum = result;
    obj.items = list;
    _refreshObjLS(obj);
    _refreshCounter();

    var itTotal = item.sum * item.pvp;
    incBlock.find('.js-it-carrito-total-pvp').text(itTotal.toLocaleString('es-ES'));

    var itPriceMdo = _calculatePriceMdo(item.tm, item.sum);
    incBlock.find('.js-it-carrito-precio-montaje').text(itPriceMdo.toLocaleString('es-ES'));

    var subTotal = _calculateSubtotal(itTotal, itPriceMdo);
    incBlock.find('.js-it-carrito-subtotal').text(subTotal.toLocaleString('es-ES'));

    var total = _calculateTotal();
    $('.js-total-pvp').text(total.toLocaleString('es-ES'));
  };

  var _calculateSubtotal = function _calculateSubtotal(total, mdo) {
    return total + mdo;
  };

  var _calculateTotal = function _calculateTotal() {
    var list = _getObjLS().items;
    var total = 0;

    for (var i = 0; i < list.length; i++) {
      var _item = list[i];
      var itPriceMdo = _calculatePriceMdo(_item.tm, _item.sum);
      var itTotal = _item.sum * _item.pvp;

      total += _calculateSubtotal(itTotal, itPriceMdo);
    }

    return total;
  };

  var _calculatePriceMdo = function _calculatePriceMdo(tm, sum) {
    var rawNumber = parseFloat(profilesControl.getCurMdo().precio) / 60 * tm * sum;
    var number = parseInt(rawNumber * 100) / 100;
    return number;
  };

  var _addDocEvents = function _addDocEvents() {
    // Si la lista no está vacía
    $('.js-imprimir').on('click', function () {
      // El parámetro es para indicar si después de generarlo se muestra el formulario para enviar por email
      var objLS = _getObjLS();
      if (_getTotalCount(objLS) > 0) _controlPrintOrSend(false);
    });

    $('.js-envio').on('click', function () {
      var objLS = _getObjLS();
      if (_getTotalCount(objLS) > 0) {
        if ($(this).hasClass('js-top')) {
          $('html, body').animate({ 'scrollTop': $('.js-envForm-container').offset().top }, 300);
        }

        _controlPrintOrSend(true, $(this));
      }
    });
  };

  var _generateJsonDoc = function _generateJsonDoc() {
    var objLS = _getObjLS();
    var legalsArray = _getLegal();
    var json = {
      concesion: profilesControl.getCurConcesion(),
      pvptotal: String(_calculateTotal().toLocaleString('es-ES')),
      items: _generateArray4Doc(objLS.items),
      notalegal1: legalsArray[0],
      notalegal2: legalsArray[1],
      notalegal3: legalsArray[2]
    };

    $('#js-doc-data').val(JSON.stringify(json));
  };

  var _controlPrintOrSend = function _controlPrintOrSend(sendMail, trigger) {
    var $formMail = $('#js-form-envio');
    var $sendInput = $('#js-envio-input');

    if (sendMail) {
      /// Mostrar el formulario
      sendMailForm.init(trigger);
      $sendInput.val(1);
    } else {
      $sendInput.val(0);
      _generateJsonDoc();

      if (typeof validator !== 'undefined') {
        $('.js-envForm-container').removeClass('visible');
        validator.destroy();
        validator = undefined;
        $formMail.submit();
      } else {
        $formMail.submit();
      }
    }
  };

  var _generateArray4Doc = function _generateArray4Doc(arr) {
    var result = [];

    for (var i = 0; i < arr.length; i++) {
      var a = arr[i];

      var _item2 = {
        modelo: a.modelo + ' (' + a.modelocode + ')',
        nombre: a.nombre,
        ref: a.ref,
        imagen: a.imagen,
        pvpUnidad: parseFloat(a.pvp).toLocaleString('es-ES'),
        unidades: String(a.sum),
        pvpPiezas: String((a.pvp * a.sum).toLocaleString('es-ES')),
        precioMontaje: String(_calculatePriceMdo(a.tm, a.sum).toLocaleString('es-ES')),
        total: String(_calculateSubtotal(a.pvp * a.sum, _calculatePriceMdo(a.tm, a.sum)).toLocaleString('es-ES'))
      };
      result.push(_item2);
    }

    return result;
  };

  var _validateFormMail = function _validateFormMail($formMail) {
    return false;
  };

  var _removeItem = function _removeItem($block, ref, moi) {
    _removeAllFromCarList(ref, moi);
    $block.remove();
    _makeList();
  };

  var _callClearList = function _callClearList() {
    var list = _getObjLS().items;
    var obj = _getObjLS();
    if (list.length > 0) {
      var alertCbx = $.colorbox({
        href: '.js-delete-msg-1',
        inline: true,
        width: '90%',
        maxWidth: '400px',
        height: 'auto',
        overlayClose: true,
        className: 'alerta',
        onComplete: function onComplete() {
          $('.js-aceptar').on('click', function () {
            _clearList(obj);
            // Ocultar el form de envío si está visible
            $('.js-envForm-container').removeClass('visible');
            $.colorbox.close();
          });
          $('.js-cancelar').on('click', function () {
            $.colorbox.close();
          });
        }
      });
    }
  };

  var _clearList = function _clearList(obj) {
    list = [];
    obj.items = list;
    _refreshObjLS(obj);
    _makeList();
  };

  var _initList = function _initList() {
    _makeList();
    _addDocEvents();
    // Comprobamos si existe la URL de vuelta
    if (typeof sessionStorage.backFromCartList !== 'undefined') {
      $('.js-volver-carrito').removeClass('hidden').on('click', function () {
        window.location.href = sessionStorage.backFromCartList;
      });
    } else {
      $('.js-volver-carrito').addClass('hidden');
    }
    // $('.js-volver-carrito').on('click', () =>{ history.go(-1)})
    $('.js-vaciar-lista').on('click', function () {
      _callClearList();
    });
  };

  var _setLegal = function _setLegal(arrayTxts) {
    arrLegalTexts = arrayTxts;
  };

  return {
    init: _init,
    getCartListLS: _getObjLS,
    checkboxListener: _checkboxListener,
    initList: _initList,
    matchRefAndMoi: _matchRefAndMoi,
    setLegal: _setLegal,
    makeList: _makeList,
    generateJsonDoc: _generateJsonDoc
  };
}();

var validator = void 0;

var sendMailForm = function () {
  var _init = function _init(trigger) {
    var $dropdown = $('.js-envForm-container');
    var form = document.getElementById('js-form-envio');
    var requiredMsg = utils.getLangMessages().formRequired;
    var emailNoValid = utils.getLangMessages().formEmail;
    validator = $(form).validate({
      rules: {
        pvNombre: {
          required: true
        },
        pvEmail: {
          required: true,
          email: true
        },
        pvNombreRt: {
          required: true
        },
        pvEmailRt: {
          required: true,
          email: true
        },
        pvAsunto: {
          required: true
        }
      },
      messages: {
        pvNombre: {
          required: requiredMsg
        },
        pvEmail: {
          required: requiredMsg,
          email: emailNoValid
        },
        pvNombreRt: {
          required: requiredMsg
        },
        pvEmailRt: {
          required: requiredMsg,
          email: emailNoValid
        },
        pvAsunto: {
          required: requiredMsg
        }

      },
      errorElement: 'span',
      submitHandler: function submitHandler(form) {
        cartList.generateJsonDoc();
        form.submit();
      }
    });

    if ($dropdown.hasClass('visible') && !trigger.hasClass('js-top')) {
      $dropdown.removeClass('visible');
    } else {
      $dropdown.addClass('visible');
      if (!trigger.hasClass('js-top')) {
        form.reset();
        validator.resetForm();
      }
    }
  };
  return {
    init: _init
  };
}();